export const question = {
    labels: {
        range: "Minimo e Máximo",
        measure: "Medida",
        minimum: "Mínimo",
        maximum: "Máximo",
    },
    placeholders: {
        name: "Informe o nome do campo",
        measure: "Unidade de medida",
    },
    types: {
        title: "Título",
        input: "Texto",
        textarea: "Texto Longo",
        select: "Seleção",
        radio: "Opções",
        checkbox: "Checkbox",
        photo: "Foto",
        // file: "Arquivo",
        sign: "Assinatura",
    },
    file_types: {
        document: "Documento",
        image: "Imagem",
    },
    texts: {
        add_question: "Adicionar Pergunta",
        edit_question: "Editar Pergunta",
        del_question: "Excluir Pergunta",
        del_confirm: "Você deseja excluir a pergunta <strong>'{concat}'</strong>?",
        as_answer: "Tem Resposta?",
    },
};
